import React, { useEffect } from "react";
import * as echarts from "echarts";
import { Font } from "@react-pdf/renderer";

export const ChartGastos = ({ name, data, sucursales }) => {
  useEffect(() => {
    const dom = document.getElementById(name);
    const myChart = echarts.init(dom, null, {
      renderer: "canvas",
      useDirtyRect: false,
    });

    // const shortMonths = ["Ene", "Feb", "Mar", "Abr", "May", "Jun"]; //, 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    // const fullMonths = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio"]; //, 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    const shortMonths = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ];
    const fullMonths = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    // const currentMonth = new Date().getMonth() + 1; // Obtener el mes actual (1-12)
    const currentMonth = data.gastos.length;

    // Datos de ejemplo para las ventas netas
    // const ejercicioActualData = [68354, 75756, 34245, 57659, 89500, 78409];
    // const ejercicioAnteriorData = [70854, 85033, 37845, 58299, 102234, 159283];
    // const proyeccionData = [69874, 75874, 32988, 57867, 95989, 80787];

    const formatmiles = (number) => {
      return Math.floor((number ?? 0) / 1000);
    };

    const formatmiles2 = (number) => {
      return number.toLocaleString("en-US");
    };

    const ejercicioActualData = data?.gastos
      ? data.gastos.map((item) => formatmiles(item.gastos))
      : [];
    const ejercicioAnteriorData = data?.gastosanterior
      ? data.gastosanterior.map((item) =>
          formatmiles(item.gastosejercicioanterior)
        )
      : [];
    const proyeccionData = data?.gastosproyectados
      ? data.gastosproyectados.map((item) => formatmiles(item.gastoproyectados))
      : [];

    const añoActual = new Date().getFullYear();
    const añoAnterior = añoActual - 1;

    const maxDataValue = Math.max(
      ...ejercicioActualData,
      ...ejercicioAnteriorData,
      ...proyeccionData
    );

    const option = {
      // title: {
      //   text: 'Ventas Netas',
      //   left: '0',
      //   backgroundColor: '#035917',
      //   padding: [4, 147],
      //   textStyle: {
      //     color: '#ffffff',
      //     fontSize: 16,
      //   },
      //   borderRadius: [5, 5, 0, 0]
      // },

      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: function (params) {
          let tooltipText = params[0].name;
          fullMonths.forEach((month, index) => {
            if (shortMonths[index] === params[0].name) {
              tooltipText = month;
            }
          });
          return `
            <div>${tooltipText}</div>
            ${params
              .map(
                (param) => `
              <div>${param.seriesName}: $${formatmiles2(param.value)}</div>
            `
              )
              .join("")}
          `;
        },
      },
      legend: {
        top: "5%",
        data: [`${añoActual}`, `${añoAnterior}`, "Proyección"],
        textStyle: {
          fontSize: 14,
        },
      },
      grid: {
        left: "5%",
        right: "4%",
        bottom: "20%",
        top: "20%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: shortMonths.slice(0, currentMonth),
          axisPointer: {
            type: "shadow",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          // name: "Uni. Vendidas",
          min: 0,
          max: Math.ceil(maxDataValue * 1.1), // Establecer el máximo un poco más alto para espacio adicional
          interval: Math.ceil(maxDataValue / 5), // Establecer intervalo basado en el máximo
          axisLabel: {
            formatter: "{value}",
          },
        },
        {
          type: "value",
          // name: "Proyección",
          min: 0,
          max: Math.ceil(maxDataValue * 1.1), // Establecer el máximo un poco más alto para espacio adicional
          interval: Math.ceil(maxDataValue / 5), // Establecer intervalo basado en el máximo
          axisLabel: {
            formatter: "{value}",
          },
        },
      ],
      series: [
        {
          name: `${añoActual}`,
          type: "bar",
          data: ejercicioActualData,
          itemStyle: {
            color: "#035917",
          },
        },
        {
          name: `${añoAnterior}`,
          type: "bar",
          data: ejercicioAnteriorData,
          itemStyle: {
            color: "#dae6be",
          },
        },
        {
          name: "Proyección",
          type: "line",
          yAxisIndex: 1,
          data: proyeccionData,
          itemStyle: {
            color: "#ffc107",
          },
        },
      ],
    };

    myChart.setOption(option);

    // Redimensionar el gráfico cuando cambie el tamaño de la ventana
    window.addEventListener("resize", () => {
      myChart.resize();
    });

    // Limpiar el gráfico al desmontar el componente
    return () => {
      window.removeEventListener("resize", () => {
        myChart.resize();
      });
      myChart.dispose();
    };
  }, [data]);

  return <div id={name} style={{ width: "399px", height: "290px" }}></div>;
};
